import { TagPrefix } from '@fiverr-private/data_display';

export default TagPrefix;
